import { fetchAuthSession } from "aws-amplify/auth";
import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";

/* TODO - CONNECT TO BE, DRAFT SHOWN ONLY FOR BETA PURPOSES */
export const useEmergencyContactSoftAddMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return { id: null, name: null, relationship: null, phone: null };
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["emergencyContactsQuery"], (oldData) =>
        oldData ? [...oldData, { ...data }] : oldData
      );
    },
  });
};

export const useEmergencyContactPostMutation = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (emergencyContactFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "pcmedapi",
        path: "/profile/emergency-contacts/" + id,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: emergencyContactFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emergencyContactsQuery"] });
    },
  });
};

export const useEmergencyContactPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (emergencyContactFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "pcmedapi",
        path: "/profile/emergency-contacts/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: emergencyContactFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emergencyContactsQuery"] });
    },
  });
};

export const useEmergencyContactDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ecId) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "pcmedapi",
        path: "/profile/emergency-contacts/" + ecId,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emergencyContactsQuery"] });
    },
  });
};

export const useEmergencyContactSoftDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, index }) => {
      if (id) {
        console.log("server delete id", id);
      } else {
        console.log("soft delete index: ", index);
      }

      return { index };
    },
    onSuccess: (data) => {
      console.log("success: ", data);
      queryClient.setQueryData(["emergencyContactsQuery"], (oldData) => {
        console.log("oldData", oldData);
        console.log("data", data);

        if (data.index >= 0) {
          oldData.splice(data.index, 1);
          return oldData;
        }
        return oldData;
      });
    },
  });
};
